import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  paragraph: {
    paddingBottom: theme.spacing(2),
  },
  divider: {
    height: 1,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    backgroundColor: theme.palette.action.main,
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  picturePreview: {
    width: 240,
    maxWidth: '100%',
    marginRight: theme.spacing(1),
    cursor: 'pointer',
  },
  title: {
    paddingBottom: theme.spacing(3),
    textTransform: 'uppercase',
    color: theme.palette.action.main,
  },
}));
